<template>
  <v-row :style="'background-color:' + $finColors.accentBlue" class="fill-height ma-0 pa-6 pl-5">
    <v-col class="pr-3" cols="12" sm="7">
      <p class="academy-title mr-sm-12 mb-3" style="color: #ffffff;">Sparbuch versus Börse - was ist möglich?</p>
      <p style="color: #ffffff;">
        <fin-lexicon-text
          auto-solve
          text="Schau dir hier an was aus deinem Geld geworden wäre, wenn du es vom Sparbuch genommen und am Kapitalmarkt hättest für dich arbeiten lassen."/>
      </p>
      <v-btn class="d-flex float-right float-sm-left"
             outlined
             dark
             @click="openDemoTool">
        Ausprobieren
      </v-btn>
    </v-col>
    <v-col class="d-flex align-start justify-end" cols="12" sm="5">
      <!-- TODO img ok? -->
      <v-img
        :src="require('@/assets/academy/demo-tool.gif')"
        class="img"
        contain/>
    </v-col>
  </v-row>
</template>

<script>
import FinLexiconText from "@/components/common/lexicon/LexiconText"
import {EventBus} from "@/plugins/fincraft"

export default {
  name: "FinAcademyDemoTool",
  components: {FinLexiconText},
  methods: {
    openDemoTool() {
      EventBus.$emit('showTool', true)
    },
  }
}
</script>

<style lang="scss" scoped>

.academy-title {
  font-family: TiemposText;
  font-size: 20px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
}
</style>
